<template>
	<div class="divider">
		<img :src="require(`@/assets/images/divider/bar_blue.svg`)" alt="" >
		<hr class="red-bar"/>
		<div class="image-container">
			<div class="overlay">
				 <p>
					{{quote}}
				</p>
				<p v-if="author"> - {{author}}</p>
			</div>
            <img :src="require(`@/assets/images/divider/${img_src}`)" class="divider_img" alt="">
        </div>
		<hr class="red-bar"/>
	</div>
</template>

<script>
export default {
	name: "divider",
	props: ["img_src", "quote", "author"],
};
</script>

<style lang="scss" scoped>
.divider{
	position:relative;
	.red-bar{
		height:4px;
		width:100%;
		color: #CC3433;
		background: #CC3433;
		margin: 0px auto;
		opacity:1;
		// @include media-breakpoint-down(sm) {
		// 	width:340px;
		// }
	}
	img{
		width:100%;
	}
	.image-container{
		margin: 5px 0px;
		position:relative;

		   // border-radius: 40px;
		    // background-image: linear-gradient(to right, black, transparent);
		   // background-image: linear-gradient(270deg, rgba(28,28,28,0) 0%, #0C0C0C 100%);
		   .overlay{
			   display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-end;
				padding: 0px 100px 0px 100px;
				gap: 10px;
				color:white;
				z-index: 1;
				position: absolute;
				// left: 0px;
				right: 0px;
				top: 0.35px;
				bottom: -0.35px;
				width:50%;
				@include media-breakpoint-down(sm) {
				   padding: 0px;
				   width:50%;
				   right: 30px;
				}
				p{
					font-family: 'Verlag Light';
					font-style: normal;
					font-weight: 325;
					font-size: 16px;
					line-height: 145%;
					text-align: right;
					@include media-breakpoint-down(sm) {
					  font-size: 12px;
					   // width:100%;
					}
				}
			   // position: absolute;
				// top: 30%;
				// right: 30px;
			   //
				// height: 250px;

				// color:white;
				// // background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0.12) 19.79%, rgba(0, 0, 0, 0.15) 57.81%, #000000 85.94%), linear-gradient(175.39deg, rgba(0, 0, 0, 0.15) 3.52%, rgba(0, 0, 0, 0.375) 96.13%);
				// // // transform: translate(0%,-50%);
				// z-index: 10;

		   }
	   }
	.divider_img{
		object-fit: cover;
		object-position:center;
		position:relative;
		height: 250px;
		@include media-breakpoint-down(sm) {
			height: 150px;
		}
	}
}
</style>
